import { isIdentityVerificationModalOrRoute } from "@faire/retailer-visitor-shared/components/App/AppModals/isIDV";
import { HeaderPriorityProvider } from "@faire/retailer-visitor-shared/components/HeaderPriorityRenderer/HeaderPriorityPriovider";
import { AppNudgeProvider } from "@faire/retailer-visitor-shared/features/Nudges/useAppNudgeStore";
import { isMobileApp } from "@faire/retailer-visitor-shared/lib/isMobileApp";
import { useStickyNavContentPositions } from "@faire/retailer-visitor-shared/navbar/useStickyNavContentPositions";
import React from "react";

import { ToastContainer } from "../../../Wrapper/ToastContainer";
import { useClassName } from "../../../Wrapper/useClassName";
import { useNonStickyHeader } from "../../../Wrapper/useNonStickyHeader";
import { useResizeRefCallback } from "../../../Wrapper/useResizeRefCallback";
import { useStyle } from "../../../Wrapper/useStyle";

type Props = {
  children: React.ReactNode;
  hasNoTopBanner?: boolean;
  hasToastContainer?: boolean;
};

export const LightweightWrapper: React.FC<Props> = ({
  children,
  hasNoTopBanner,
  hasToastContainer,
}) => {
  const { contentCallback, contentRef } = useResizeRefCallback();
  const { shouldRetainOriginalPosition } = useStickyNavContentPositions();
  const nonStickyHeader = useNonStickyHeader({ hasLinkedPOS: false });

  const style = useStyle({
    bannerHeight: 0,
    contentRef,
    hasNoTopBanner,
    isNotificationPreviewVisible: false,
    isShowingMarketCountdownBanner: false,
    nonStickyHeader,
    notificationPreview: undefined,
    shouldRetainOriginalPosition,
    shouldShowSaleAnnouncementTooltip: false,
  });
  const className = useClassName({
    nonStickyHeader,
    shouldRetainOriginalPosition,
  });

  if (isMobileApp() && isIdentityVerificationModalOrRoute()) {
    return null;
  }

  return (
    <HeaderPriorityProvider value={{ isNotificationPreviewVisible: false }}>
      <AppNudgeProvider>
        <div
          data-test-id="header-content"
          ref={contentCallback}
          className={className}
          style={style}
        >
          {children}
        </div>
      </AppNudgeProvider>
      {hasToastContainer ? <ToastContainer style={style} /> : null}
    </HeaderPriorityProvider>
  );
};
